import React, { useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Select from "react-select";
import { Button, Img, Text } from "components";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdClose } from "react-icons/md";
// import { useNavigate } from "react-router-dom";

const PatientCreateNewAccount = ({ onClose }) => {
  // const navigate = useNavigate();
  const [hospital, setHospital] = useState([]);
  const [genders, setGenders] = useState([]);
  const [showPass, setShowPass] = useState(false);
  //const [ageFields, setAgeFields] = useState({ years: "", months: "" });
  //const [dob, setDob] = useState("");
  const handlePasswordToggle = () => {
    setShowPass(!showPass);
  };
  const [showPass2, setShowPass2] = useState(false);
  const handlePasswordToggle2 = () => {
    setShowPass2(!showPass2);
  };

  //calculate age from DOB
  const calculateAge = (birthdate) => {
    if (!birthdate) return { years: "", months: "" };

    const today = new Date();
    const birth = new Date(birthdate);

    let years = today.getFullYear() - birth.getFullYear();
    let months = today.getMonth() - birth.getMonth();

    if (
      months < 0 ||
      (months === 0 && today.getDate() < birth.getDate())
    ) {
      years--;
      months += 12;
    }

    return { years, months };
  };

  function handleSubmit(values) {
    axios
      .post(
        "/api/authentication/patient-api/patient-signup-master/create",
        values,
      )
      .then((response) => {
        console.log("Response data:", response.data);
        if (response.data.status === true) {
          const patientId = response.data.id;
          console.log("patientId", response.data.id);
          console.log("patientId2", response.data);

          const updatedValues = {
            ...values,
            id: patientId,
          };

          updatePatient(updatedValues);
          toast.success(response.data.message, {
            autoClose: 400,
            onClose: () => {
              if (onClose) onClose();
            },
          });
        } else {
          toast.error(response.data.message, {
            autoClose: 1500,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  useEffect(() => {
    getHospital();
  }, []);
  const obj_Doctor = {};
  const headers = null;
  const getHospital = () => {
    axios
      .post("/api/authentication/hospitalname/get", obj_Doctor, { headers })
      .then((response) => {
        setHospital(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log("Error");
      });
  };

  const updatePatient = async (values) => {
    // values.birthdate = dob;

    try {
      const response = await axios.put(
        "/api/authentication/patient-api/update/patient",
        values,
        headers,
      );
    } catch (error) {
      console.error("Error creating patient:", error);
    }
  };
  useEffect(() => {
    getGender();
  }, []);

  const obj = {};
  const getGender = () => {
    axios
      .post("/api/authentication/gender/get", obj, headers)
      .then((response) => {
        setGenders(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log("Error");
      });
  };

  // const handleDobChange = (e) => {
  //   const selectedDob = e.target.value;
  //   setDob(selectedDob);
  //   if (selectedDob) {
  //     const currentDate = new Date();
  //     const birthDate = new Date(selectedDob);
  //     let years = currentDate.getFullYear() - birthDate.getFullYear();
  //     let months = currentDate.getMonth() - birthDate.getMonth();

  //     if (
  //       months < 0 ||
  //       (months === 0 && currentDate.getDate() < birthDate.getDate())
  //     ) {
  //       years--;
  //       months += 12;
  //     }

  //     setAgeFields({ years: years.toString(), months: months.toString() });
  //     // formik.setFieldValue("birthdate", selectedDob);
  //   } else {
  //     setAgeFields({ years: "", months: "" });
  //   }
  // };

  // const calculateDobFromAge = (years, months) => {
  //   const currentDate = new Date();
  //   const calculatedDate = new Date(
  //     currentDate.getFullYear() - years,
  //     currentDate.getMonth() - months,
  //     currentDate.getDate(),
  //   );
  //   const formattedDate = calculatedDate.toISOString().split("T")[0];
  //   return formattedDate;
  // };

  // const handleAgeChange = (field, value) => {
  //   let updatedAgeFields = { ...ageFields, [field]: value };
  //   setAgeFields(updatedAgeFields);

  //   if (updatedAgeFields.years || updatedAgeFields.months) {
  //     const calculatedDob = calculateDobFromAge(
  //       parseInt(updatedAgeFields.years) || 0,
  //       parseInt(updatedAgeFields.months) || 0,
  //     );
  //     setDob(calculatedDob);

  //     // formik.setFieldValue("birthdate", calculatedDob);
  //   }
  // };

  return (
    <div className="flex flex-col">
      {/* <ToastContainer /> */}
      <div className="page-header">
        <div className="page-header-left">
          <Text className="page-title cursor-default">
            Create An Account
          </Text>
        </div>
        <div className="page-header-right">
          <MdClose className="text-[25px] mr-3 cursor-pointer" onClick={onClose} />
        </div>

      </div>
      <hr />
      <div className="mt-3">
        <Formik
          initialValues={{
            id: "",
            hospital_id: "",
            login_username: "",
            mobilenumber: "",
            gmailaddress: "",
            login_password: "",
            confirmPassword: "",
            gender_id: "",
            birthdate: "",
            isactive: true,
          }}
          validationSchema={Yup.object().shape({
            login_username: Yup.string()
              .trim()
              .required("Full name is Required"),
            mobilenumber: Yup.string()
              .required("Mobile number is Required")
              .matches(/^[6-9]\d{9}$/, "Mobile number must be 10 digits"),
            gmailaddress: Yup.string()
              .email("Enter a valid email address")
              .required("Email is required"),
            login_password: Yup.string().required("Password is Required"),
            confirmPassword: Yup.string()
              .oneOf([Yup.ref("login_password"), null], "Passwords must match")
              .required("Confirm Password is Required"),
            gender_id: Yup.string().required("Gender is Required"),
            // birthdate: Yup.string().required("Age is Required"),
            hospital_id: Yup.string().required("Hospital name is Required"),
            birthdate: Yup.date()
              .required("Birthdate is required")
              .max(new Date(), "Birthdate cannot be in the future")
          })
          }
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
            <Form>
              <div className="flex flex-col gap-2 items-center justify-center w-[100%] md:w-full">

                <div className="flex flex-col md:gap-10 items-center justify-center w-[100%] md:w-full ">
                  <div className="grid grid-cols-2 gap-x-5 items-start justify-around w-[100%] md:w-full px-5 md:px-10">
                    <div className="mt-0 gap-1 flex flex-col items-start justify-center w-full ">
                      <div className="flex flex-row form-label">
                        <label htmlFor="login_username">Full Name</label>
                        <span className="form-error">*</span>
                      </div>
                      <input
                        name="login_username"
                        placeholder="Enter Your Full Name"
                        type="text"
                        className="md:h-auto placeholder:child-text child-text sm:h-auto  text-left w-full rounded-md h-8"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <div className="min-h-[18px]">
                        <ErrorMessage
                          name="login_username"
                          component="div"
                          className="form-error text-xs"
                        />
                      </div>
                    </div>

                    <div className="mt-0 gap-1 flex flex-col items-start justify-center w-full">
                      <div className="flex flex-row form-label">
                        <label htmlFor="mobilenumber">Mobile Number</label>
                        <span className="form-error">*</span>
                      </div>

                      <input
                        name="mobilenumber"
                        placeholder="Enter Your Mobile Number"
                        type="tel"
                        maxLength="10"
                        title="Mobile number must start with 6-9 and be 10 digits"
                        className="md:h-auto placeholder:text-blue_gray-300 sm:h-auto child-text text-left w-full rounded-md h-8"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <div className="min-h-[18px]">
                        <ErrorMessage
                          name="mobilenumber"
                          component="div"
                          className="form-error text-xs"
                        />
                      </div>
                    </div>

                    <div className="mt-0 gap-1 flex flex-col items-start justify-center w-full">
                      <label htmlFor="gmailaddress">Email Id</label>
                      <input
                        name="gmailaddress"
                        placeholder="Enter Your Email Id"
                        type="email"
                        title="Enter The Valid Email Address"
                        className="md:h-auto placeholder:text-blue_gray-300 sm:h-auto child-text text-left w-full rounded-md h-8"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <div className="min-h-[18px]">
                        <ErrorMessage
                          name="gmailaddress"
                          component="div"
                          className="form-error text-xs"
                        />
                      </div>
                    </div>

                    <div className="mt-0 relative flex flex-col gap-1 w-full">
                      <div className="flex flex-row form-label">
                        <label htmlFor="login_password">Password</label>
                        <span className="form-error text-xs">*</span>
                      </div>
                      <div className="relative">
                        <input
                          name="login_password"
                          placeholder="Enter Your Password"
                          type={showPass ? "text" : "password"}
                          className="w-full rounded-md child-text placeholder:text-blue_gray-300 h-8"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <div
                          className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                          onClick={handlePasswordToggle}
                        >
                          {showPass ? (
                            <FaEye size={20} />
                          ) : (
                            <FaEyeSlash size={20} />
                          )}
                        </div>
                      </div>
                      <div className="min-h-[18px]">
                        <ErrorMessage
                          name="login_password"
                          component="div"
                          className="form-error text-xs"
                        />
                      </div>
                    </div>

                    {/* Confirm Password Input */}
                    <div className="mt-0 flex flex-col gap-1 items-start justify-center w-full relative">
                      <div className="flex flex-row form-label">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <span className="form-error text-xs">*</span>
                      </div>

                      <div className="relative w-full">
                        <input
                          name="confirmPassword"
                          placeholder="Enter Your Confirm Password"
                          type={showPass2 ? "text" : "password"}
                          className="h-8 md:h-auto placeholder:text-blue_gray-300 sm:h-auto child-text text-left w-full rounded-md p-2"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <div
                          className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                          onClick={handlePasswordToggle2}
                        >
                          {showPass2 ? (
                            <FaEye size={20} />
                          ) : (
                            <FaEyeSlash size={20} />
                          )}
                        </div>
                      </div>
                      <div className="min-h-[18px]">
                        <ErrorMessage
                          name="confirmPassword"
                          component="div"
                          className="form-error text-xs"
                        />
                      </div>
                    </div>

                    <div className="mt-0 flex flex-1 flex-col gap-1 items-start justify-start w-full">
                      <div className="flex flex-row form-label">
                        <label htmlFor="confirmPassword">Date of Birth</label>
                        <span className="form-error text-xs">*</span>
                      </div>
                      {/* <Text
                        className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                      >
                        <span className="text-black-700 font-inter form-label">
                          Date of Birth
                        </span>
                      </Text> */}
                      <input
                        name="birthdate"
                        type="date"
                        placeholder=" Enter Date of Birth"
                        value={values.birthdate}
                        onChange={(e) => setFieldValue("birthdate", e.target.value)}
                        onBlur={handleBlur}
                        className="bg-white-A700 border border-gray-400_02 border-solid h-8 rounded-md child-text w-full"
                      />
                      <div className="min-h-[18px]">
                        <ErrorMessage
                          name="birthdate"
                          component="div"
                          className="form-error text-xs"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row gap-2 px-4 mt-3 items-start justify-between w-full ">
                    <div className="flex flex-1 flex-col gap-1 items-start justify-start w-[22%]">
                      <Text
                        className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                      >
                        <span className="text-black-700 font-inter form-label">
                          Age
                        </span>
                        <span className="text-black-700 font-inter font-small">
                          (Years)
                        </span>
                      </Text>
                      {(() => {
                        const age = calculateAge(values.birthdate);

                        return (
                          <>
                            <input
                              type="text"
                              value={age.years}
                              placeholder="Age"
                              readOnly
                              className="form-input bg-gray-100 h-8 child-text rounded-md w-full mt-0"
                            />
                          </>
                        );
                      })()}
                    </div>
                    <div className="flex flex-col gap-1 items-start justify-start w-[20%]">
                      <Text
                        className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                      >
                        <span className="text-black-700 font-inter form-label">
                          (Months)
                        </span>
                      </Text>
                      {(() => {
                        const age = calculateAge(values.birthdate);

                        return (
                          <>
                            <input
                              type="text"
                              value={age.months}
                              placeholder="Month"
                              readOnly
                              className="form-input bg-gray-100 h-8 child-text rounded-md w-full mt-0"
                            />
                          </>
                        );
                      })()}
                      {/* <input
                        name="months"
                        type="number"
                        placeholder="Enter Months"
                        value={ageFields.months}
                        onChange={(e) =>
                          handleAgeChange("months", e.target.value)
                        }
                        onBlur={handleBlur}
                        // disabled={dob !== ''}
                        className="bg-white-A700 border border-gray-400_02 border-solid h-8 child-text rounded-[5px] w-full"
                      /> */}
                    </div>
                    <div className="mt-0 flex  flex-col gap-1 items-start justify-start w-[23%]">
                      <div className="flex flex-row form-label">
                        <label htmlFor="mobilenumber">Gender</label>
                        <span className="form-error">*</span>
                      </div>
                      {/* <Text
                        className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                      >
                        <span className="text-black-700 font-inter font-small">
                          Gender*
                        </span>
                      </Text> */}
                      <Select
                        name="gender_id"
                        options={genders?.map((resstate) => ({
                          label: resstate.name,
                          value: resstate.id,
                        }))}
                        classNamePrefix="custom-select"
                        className="form-label"
                        onChange={(selectedOption) => {
                          setFieldValue("gender_id", selectedOption.value);
                        }}
                        onBlur={handleBlur}
                        placeholder="Select Gender"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "30px",
                            height: "32px",
                            width: "150px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "32px",
                            padding: "0 8px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "32px",
                          }),
                        }}
                      />
                      <div className="min-h-[18px]">
                        <ErrorMessage
                          name="gender_id"
                          component="div"
                          className="form-error text-xs"
                        />
                      </div>
                    </div>
                    <div className="mt-0 flex flex-col gap-1 items-start justify-start w-[35%]">
                      <div className="flex flex-row form-label">
                        <label htmlFor="mobilenumber">Hospital</label>
                        <span className="form-error">*</span>
                      </div>
                      {/* <Text
                        className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                      >
                        <span className="text-black-700 font-inter form-label">
                          Hospital
                        </span>
                      </Text> */}
                      <Select
                        name="hospital_id"
                        options={hospital?.map((resstate) => ({
                          label: resstate.name,
                          value: resstate.id,
                        }))}
                        classNamePrefix="custom-select"
                        onChange={(selectedOption) => {
                          setFieldValue("hospital_id", selectedOption.value);
                        }}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        maxMenuHeight={100}
                        onBlur={handleBlur}
                        placeholder="Select Hospital"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({
                            ...base,
                            minHeight: "30px",
                            height: "32px",
                            width: "220px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "32px",
                            padding: "0 8px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "32px",
                          }),
                        }}
                      />
                      <div className="min-h-[18px]">
                        <ErrorMessage
                          name="hospital_id"
                          component="div"
                          className="form-error text-xs"
                        />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div className="flex flex-col md:gap-10 items-center justify-center w-[100%] md:w-full gap-y-1">
                <div>
                  <Button
                    className="btn-primary w-[250px]"
                    variant="fill"
                    type="submit"
                  // onClick={handleSubmit}
                  >
                    Sign Up
                  </Button>
                </div>
                <div className="flex gap-1 font-medium leading-[normal] min-w-[450px] md:min-w-[30%] items-center justify-center">
                  <Text className="child-text cursor-default">Already have an account?</Text>
                  <Text className="font-highlight-color child-text underline cursor-pointer" onClick={onClose}> Login</Text>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default PatientCreateNewAccount;
